import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import * as url from "helper/UrlHelper";
import { getData, putData } from "utils/Gateway";
import { formatTimestamp } from "helper/Common/CommonHelper";

import typeOptions from "data/Automation/Type.json";
import actionOptions from "data/Automation/Actions.json";

const ViewEventsPopup = ({
  automationEventId
}) => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");

  const [automationEventDetails, setAutomationEventDetails] = useState(null);
  const [isPausing, setIsPausing] = useState(false);
    const [ automationData, setAutomationData ] = useState(null);
    const [ automationExecution, setAutomationExecution ] = useState(null);


    const [ triggerType, setTriggerType ] = useState("");
    const [triggerTypeLabel, setTriggerTypeLabel] = useState("");
  const [triggerValueLabel, setTriggerValueLabel] = useState("");
    const [triggerValue, setTriggerValue] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const [isTagsLoading, setIsTagsLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");   
    const [tagList, setTagList] = useState([]);


    // Fetch automation event details
    const getAutomationEventDetails = async () => {
        setIsLoading(true);

        try {
            const requestUrl =
                url.API_BASE_URL +
                url.API_AUTOMATION_EVENTS_DETAILS +
                `/${automationEventId}?token=${token}`;

                console.log("Request URL:", requestUrl);

            const response = await getData(requestUrl);

            console.log("Response:", response);

            if (response.status) {

                const tgType = response.data.automationid?.trigger?.type || "";
                const tgValue = response.data.automationid?.trigger?.value || "";

                setAutomationEventDetails(response.data);
                setAutomationData(response.data.automationid);
                setAutomationExecution(response.executions);

                setTriggerType(tgType);
                setTriggerValue(tgValue);

            } else {
                setAlertMessage(response.message);
                setMessageType("error");
                setShowAlert(true);
            }

            setIsLoading(false);

        } catch (error) {
            setAlertMessage(error.message);
            setMessageType("error");
            setShowAlert(true);
        }
    };

    // Pause automation handler
    const pauseAutomationHandler = async () => {
        try {
          setIsPausing(true);
          const requestUrl =
              url.API_BASE_URL +
              url.API_PAUSE_AUTOMATION_EVENT +
              `/${automationEventId}?token=${token}`;

          const response = await putData(requestUrl);
          
          setIsPausing(false);
          setAlertMessage(response.message);
          setMessageType(response.status ? "success" : "error");
          setShowAlert(true);
          if (response.status) {
              getAutomationEventDetails(); // Refresh event details after pausing
          }
        } catch (error) {
          setIsPausing(false);
          setAlertMessage(error.message);
          setMessageType("error");
          setShowAlert(true);
        }
    };

    // Reset handler
    const resetHandler = () => {

    };

    // Helper to get type label from typeOptions (no setTriggerType here)
    const getTriggerTypeLabel = (typeValue) => {
        if (!typeValue) return "";
        const found = typeOptions.find((opt) => opt.value === typeValue);
        setTriggerTypeLabel(found ? found.label : "");
    };

    const getTagLabelById = (tagId) => {

        console.log("Tag ID:", tagId);
        console.log("Tag List:", tagList);

        const tag = tagList.find((t) => t._id === tagId);
        setTriggerValueLabel(tag ? tag.label : "");
    };

    const getLinkTrackerLabelById = (linkTrackerId) => {
        const availableLinkTrackers = automationData?.trigger?.messagetemplate?.linktrackerids || [];

        if (!linkTrackerId || !availableLinkTrackers.length) {
            setTriggerValueLabel("");
            return;
        }

        const found = availableLinkTrackers.find((opt) => opt._id === linkTrackerId);
        setTriggerValueLabel(found ? found.label : "");
    }

    //function for get all tags
    const getAllTags = async () => {

        setIsTagsLoading(true);
        setTagList([]);
        try {
        let requestUrl =
            url.API_BASE_URL + url.API_GET_ALL_TAGS + `?token=${token}`;

        // console.log(requestUrl);
        const response = await getData(requestUrl);
        console.log("tag list response", response);

        if (response.status) {
            setTagList(response.data);
        }
        } catch (error) {
            console.log(error.message);
        }

        setIsTagsLoading(false);
    };

    useEffect(() => {
        console.log("Automation Event ID:", automationEventId);

        if (automationEventId) {
            getAllTags();
            getAutomationEventDetails();
        }
        // eslint-disable-next-line
    }, [automationEventId]);

    // Effect
    useEffect(() => {
    
        const triggerTypeLabel = getTriggerTypeLabel(triggerType);
        console.log("Trigger Type:", triggerType, "Label:", triggerTypeLabel);

        if(triggerType === "tag_created" || triggerType === "tag_deleted") {
            console.log("Trigger Value by Tag :", triggerValue);
            getTagLabelById(triggerValue);
        }
        if(triggerType === "mail_linktracker_label_added") {
            console.log("Trigger Value by Link Tracker:", triggerValue);
            getLinkTrackerLabelById(triggerValue);
        }
    }, [triggerType, triggerValue]);

 

  return (
    <div
      className="offcanvas md offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="viewAutomationEvent"
      aria-labelledby="viewAutomationEventLabel"
    >
      <div className="offcanvas-header gradient-light p-4">
        <div>
          <h3 className="offcanvas-title mb-2" id="viewAutomationEventLabel">
            {t("Automation Event Details")}
          </h3>
        </div>
       
        <button
          type="button"
          className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body d-flex flex-column p-0">
        <div className="automation-details flex-fill p-4">
          {isLoading || isTagsLoading ? (
            <div className="placeholder-glow">
              <div className="placeholder col-12 mb-2" style={{ height: 24 }}></div>
              <div className="placeholder col-10 mb-2" style={{ height: 24 }}></div>
              <div className="placeholder col-8 mb-2" style={{ height: 24 }}></div>
              <div className="placeholder col-6 mb-2" style={{ height: 24 }}></div>
              <div className="placeholder col-4 mb-2" style={{ height: 24 }}></div>
            </div>
          ) : !automationEventDetails ? (
            <div className="d-flex flex-column align-items-center justify-content-center py-5">
              <span className="material-symbols-outlined fs-1 text-muted mb-3" style={{ fontSize: 48 }}>
                info
              </span>
              <h5 className="text-muted mb-2">{t("No records found")}</h5>
              <p className="text-secondary">{t("There are no automation event details available for this record.")}</p>
            </div>
          ) : (
            <>
              {/* Section A: Automation Trigger Details */}
              <div className="mb-4">
                <h5 className="fw-bold mb-3">{t("Automation Trigger")}</h5>
                <div className="table-responsive">
                  <table className="table table-borderless table-sm align-middle mb-0" style={{ maxWidth: 800 }}>
                    <tbody>
                      <tr>
                        <th className="text-muted fw-semibold ps-3" style={{ width: "180px" }}>{t("Module")}</th>
                        <td>{automationData?.trigger?.module?.name ?? '-'}</td>
                        <td>
                          {automationEventDetails?.leadid && (
                            <>
                              <p>{automationEventDetails.leadid.name}</p>
                              <p>{automationEventDetails.leadid.email}</p>
                            </>
                          )}

                          {automationEventDetails?.userid && (
                            <>
                              <p>{automationEventDetails.userid.name}</p>
                              <p>{automationEventDetails.userid.email}</p>
                            </>
                          )}

                          {automationEventDetails?.contactid && (
                            <>
                              <p>{automationEventDetails.contactid.name}</p>
                              <p>{automationEventDetails.contactid.email}</p>
                            </>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th className="text-muted fw-semibold ps-3">{t("Action Type")}</th>
                        <td>{triggerTypeLabel}</td>
                        <td></td>
                      </tr>
                      {triggerType === 'mail_linktracker_label_added' && (
                        <tr>
                          <th className="text-muted fw-semibold ps-3">{t("Mail Template")}</th>
                          <td>{automationData?.trigger?.messagetemplate?.name ?? '-'}</td>
                          <td></td>
                        </tr>
                      )}
                      <tr>
                        <th className="text-muted fw-semibold ps-3">
                          {triggerType === "mail_linktracker_label_added" ? t("Link Tracker Label") : t("Tag Label")}
                        </th>
                        <td>{triggerValueLabel}</td>
                        <td></td>
                      </tr>
                      <tr>
                        <th className="text-muted fw-semibold ps-3">
                          {t("Triggered At")}
                        </th>
                        <td>{formatTimestamp(automationEventDetails.createdAt)}</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Section B: Steps Executed */}
              <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="fw-bold mb-0">{t("Steps Executed")}</h5>
                  {automationEventDetails.status === "1" && automationEventDetails.processed == false && (
                    <button
                      className="btn btn-warning btn-sm"
                      onClick={pauseAutomationHandler}
                      disabled={isPausing}
                    >
                      {t("Stop this Event")}
                      {isPausing && (
                        <span className="mx-2 spinner-border spinner-border-sm" role="status"></span>
                      )}
                    </button>
                  )}
                  {automationEventDetails.status === "2" && automationEventDetails.processed == false && (
                    <span className="badge bg-danger">{t("Stopped")}</span>
                  )}
                  
                </div>
                {automationData && automationData.steps && automationData.steps.length > 0 ? (
                  <div className="steps-list">
                    {automationData.steps.map((step, idx) => {
                      // Get action label from actionOptions
                      const actionLabel = (() => {
                        const found = actionOptions.find(opt => opt.value === step.action);
                        return found ? found.label : (step.action || "-");
                      })();
                      return (
                        <div key={idx} className="row border rounded-3 mb-3 p-3 g-0">
                          {/* Left Column: Step Details */}
                          <div className="col-md-6 col-12 pe-md-4 mb-3 mb-md-0">
                            <div className="mb-2">
                              <span className="fw-semibold">{t("Step Order")}:</span> {step.order}
                            </div>
                            <div className="mb-2">
                              <span className="fw-semibold">{t("Action")}:</span> {actionLabel}
                            </div>
                            {step.action === "wait" && (
                              <div className="mb-2">
                                <span className="fw-semibold">{t("Wait Duration")}:</span> {step.duration} min
                              </div>
                            )}
                            {step.messagetemplate && (
                              <div className="mb-2">
                                <span className="fw-semibold">{t("Mail Template")}:</span> {step.messagetemplate.name || "-"}
                              </div>
                            )}
                            {step.tag && (
                              <div className="mb-2">
                                <span className="fw-semibold">{t("Tag")}:</span> {step.tag.title || "-"}
                              </div>
                            )}
                          </div>
                          {/* Right Column: Execution Status */}
                          <div className="col-md-6 col-12 ps-md-4 border-start-md">
                            <div className="mb-2">
                              <span className="fw-semibold">{t("Execution Status")}:</span>{" "}
                              {(() => {
                                const completedStep = automationExecution?.stepscompleted?.find(
                                  (completed) => completed._id === step._id
                                );
                                const failedStep = automationExecution?.stepsfailed?.find(
                                  (failed) => failed._id === step._id
                                );

                                if (completedStep) {
                                  return (
                                    <>
                                      <span className="badge bg-success">{t("Completed")}</span>
                                      <div className="text-muted mt-1">
                                        {formatTimestamp(completedStep.createdAt)}
                                      </div>
                                    </>
                                  );
                                } else if (failedStep) {
                                  return (
                                    <>
                                      <span className="badge bg-danger">{t("Failed")}</span>
                                      <div className="text-muted mt-1">
                                        {formatTimestamp(failedStep.createdAt)}
                                      </div>
                                    </>
                                  );
                                } else {
                                  return (
                                    <>
                                      <span className="badge bg-secondary">{t("Next")}</span>
                                    </>
                                  );
                                }
                              })()}
                            </div>
                            {step.executedAt && (
                              <div className="mb-2">
                                <span className="fw-semibold">{t("Executed At")}:</span>{" "}
                                {formatTimestamp(step.executedAt)}
                              </div>
                            )}
                            {step.result && (
                              <div className="mb-2">
                                <span className="fw-semibold">{t("Result")}:</span> {step.result}
                              </div>
                            )}
                            {/* Add more execution-related fields if available */}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <p className="text-muted">{t("No steps executed or available.")}</p>
                )}
              </div>

              {/* Section C: Status of Event Execution */}
              <div>  
                <h5 className="fw-bold mb-3">{t("Event Execution Status")}</h5>
                <p className="fs-md fw-semibold mb-1">{t("Status")}</p>
                <p>{automationExecution.executionstatus}</p>
                <p className="fs-md fw-semibold mb-1">{t("Last Updated")}</p>
                <p>{formatTimestamp(automationExecution ? automationExecution.updatedAt : automationEventDetails.updatedAt)}</p>
                {/* Add more status-related fields as needed */}
              </div>
            </>
          )}
        </div>
    
      </div>
    </div>
  );
};



export default ViewEventsPopup;
